import { api, ApiError } from './api';
import { auth } from './firebase';

/** Como `api()`, pero adjunta el ID token de Firebase del usuario en sesion. */
export async function apiAuth<T>(path: string, init?: RequestInit): Promise<T> {
  const u = auth.currentUser;
  if (!u) throw new ApiError(401, 'Tu sesión expiró. Vuelve a entrar.');
  return api<T>(path, init, await u.getIdToken());
}

export { ApiError };
